export default __webpack_public_path__ + "images/24c6615afde42c6608396e266edcfb8b-Caregiver_Burnout.svg";